<template>
  <dialog-zoomer :visible="viz" v-on:close="handleClose">
    <div class="video-pop">
      <div class="close-box grey" v-on:click="handleClose"></div>
      <div class="two-columns">
        <div class="pic-column">
          <video-multi-player v-if="loaded" :videoUrl="vidurl" :externalUrl="externalUrl" />
        </div>
        <div class="text-column">
          <h2 v-if="artist">{{ artist.formatted_name }}</h2>
          <h3>{{ video.title }}</h3>
          <div class="summary" v-text="video.summary"></div>
          
          <div class="tag-panel">
            <div class="tag" v-for="tag in tags" :key= "tag"
              v-on:click.stop="handleTag(tag)">{{ tag }}</div>
          </div>
          <div class="social-panel">
            <social-panel :url="url" :media="media" :message="message" :caption="video.title" />
          </div>
        </div>
      </div>
    </div>
  </dialog-zoomer>
</template>

<script>
import apix from '@/api.js'
import DialogZoomer from '@/components/dialogs/DialogZoomer.vue'
import SocialPanel from '@/components/panels/SocialPanel.vue'
import VideoMultiPlayer from './VideoMultiPlayer.vue'

export default {
  components: {
    DialogZoomer,
    SocialPanel,
    VideoMultiPlayer
  },
  props: {
    videoId: Number
  },
  data () {
    return {
      video: {},
      fbody: '',
      tags: [],
      message: 'Seen on IllustrationX',
      loaded: false,
      vidurl: '',
      externalUrl: '',
      artist: null
    }
  },
  computed: {
    viz () {
      return (this.videoId > 0)
    },
    media () {
      if(this.videoId > 0){
        return this.vidurl
      }
      return ''
    },
    url () {
      if(this.loaded) {
        return window.location.href
      }
      return ''
    }
  },
  created () {
    this.loaded = false
    if(this.videoId) {
      this.loadData()
    }
  },
  methods: {
    getVideoUrl() {
      return 'media/videos/' + this.video.video_id + '/' + this.video.video_file
    },
    replaceImageLink (src) {
      if(src.indexOf('=') < 0) return src
      let name = src.split('=').pop()
      return this.getImageUrl(name, '500')
    },
    
    async loadData () {
      let res = await apix.get('videos/byid/' + this.videoId)
      this.loaded = true
      this.video = res.data
      if(this.video.video_file) {
        this.vidurl = this.getVideoUrl()
      }
      this.externalUrl = this.video.external_url
      let tags = this.video.tags.split('#')
      this.tags = tags.filter(el => el !== '')
      if(this.video.artist) {
        let res = await this.$store.dispatch('fetchArtist', this.video.artist)
        console.log('artist is', this.video.artist)
        if(res) {
          this.artist = res
        }
      }
    },
    handleTag(tag) {
      this.$emit('tag', tag);
    },
    handleClose () {
      this.loaded = false
      this.$emit('close')
    }
  },
  watch: {
    videoId () {
      this.loaded = false
      this.video = {}
      if(this.videoId) {
        this.loadData()
      }
      
    }
  }
}
</script>

<style scoped>
.video-pop{
  padding:45px 45px 0 45px;
  background-color:#fff;
  max-height:95vh;
  width:90vw;
  max-width:1750px;
  overflow-y:auto;
  box-sizing:border-box;
  cursor:default;
}

.two-columns{
  display:flex;
  padding-bottom:45px;
}

.two-columns .pic-column{
  width:65%;
}

.pic-column img{
  width:100%;
}

.two-columns .text-column{
  width:34%;
  margin-left:20px;
}

.text-column h2{
  margin-top:0;
  color:#000;
  width:85%;
  margin-bottom:0.5em;
}

.text-column h3{
  margin:0 0 0.5em 0;
}

.text-column .summary{
  font-size:18px;
  margin:0.5em 0 2em 0;
}

.text-column .body{
  font-size:18px!important;
  line-height:24px;
}

.video-pop a{
  color:#ce0e2d;
}

.video-pop a:hover{
  text-decoration: underline;
}

.social-panel{
  margin:16px 0;
}
</style>